"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _typography = require("../theme/typography");

var _Text = _interopRequireDefault(require("./Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getTag(typographyKey) {
  switch (_typography.TypographyKeys[typographyKey]) {
    case _typography.TypographyKeys.Header1:
      return 'h1';

    case _typography.TypographyKeys.Header2:
      return 'h2';

    case _typography.TypographyKeys.Header3:
      return 'h3';

    case _typography.TypographyKeys.Header4:
      return 'h4';

    default:
      return 'span';
  }
} // TODO: The typing here is a little sketchy


function buildTextWrapper(typographyKey) {
  const Wrapper = props => /*#__PURE__*/_react.default.createElement(_Text.default, _extends({
    tag: getTag(typographyKey),
    typography: _typography.TypographyKeys[typographyKey]
  }, props));

  Wrapper.displayName = `Text.${String(typographyKey)}`;
  return Wrapper;
}

for (const key in _typography.TypographyKeys) {
  const stringKey = key.toString();
  _Text.default[stringKey] = buildTextWrapper(key);
}

var _default = _Text.default;
exports.default = _default;